// a FELELŐS választásakor beálló support-csapat (Évi #83) — tiszta döntés, a fejléc-választó hívja
//
// a szabály (user-döntés): a jelenlegi csapat tartalmazza a kollégát → marad · pontosan egy csapat tagja → az áll
// be · több csapat tagja (a jelenlegi nélkül) → marad, de jelezzük (a jegy nem tárol szolgáltatást, így a
// „szolgáltatás csapata" nem dönthető el) · egyiknek sem tagja → marad.

export interface TeamWithMembers {
  id: string;
  name: string;
  memberIds: readonly string[];
}

export type AssigneeTeamDecision =
  | { kind: 'keep' }
  | { kind: 'set'; teamId: string }
  /** több csapat tagja, a jelenlegié nem — a csapat marad, a felület jelez */
  | { kind: 'ambiguous' };

export function teamForAssignee(
  assigneeId: string,
  currentTeamId: string | null,
  teams: readonly TeamWithMembers[],
): AssigneeTeamDecision {
  const memberOf = teams.filter((tm) => tm.memberIds.includes(assigneeId));
  if (currentTeamId !== null && memberOf.some((tm) => tm.id === currentTeamId))
    return { kind: 'keep' };
  if (memberOf.length === 1) return { kind: 'set', teamId: memberOf[0]!.id };
  if (memberOf.length > 1) return { kind: 'ambiguous' };
  return { kind: 'keep' };
}
